import $ from 'jquery';

const selector = '.field-image.c1 img';

export default class BackgroundImage {
  constructor(element) {
    this.$element = $(element);
    const src = this.$element.find(selector).attr('src');
    if (src) {
      this.$element.css('background-image', `url(${src})`);
    }
    this.$element.addClass('ready');
  }
}



// WEBPACK FOOTER //
// ./BackgroundImage.js